import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '../../api.service';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SmpConnectivityN2pComponent } from '../smp-connectivity-n2p/smp-connectivity-n2p.component';
import { N2pUpstreamEquipmentComponent } from '../n2p-upstream-equipment/n2p-upstream-equipment.component';
import { UploadFileComponent } from '../../components/common/upload-file/upload-file.component';
import { MessageComponent } from '../../components/common/message/message.component';

@Component({
  selector: 'app-dfn-djl-flow',
  standalone: true,
  imports: [
    NgxSpinnerModule,UploadFileComponent,
    ReactiveFormsModule,
    CommonModule,MessageComponent,
    SmpConnectivityN2pComponent,N2pUpstreamEquipmentComponent
  ],
  templateUrl: './dfn-djl-flow.component.html',
  styleUrl: './dfn-djl-flow.component.scss'
})
export class DfnDjlFlowComponent {
  @Input() inputData: any;
  @Input() showDFLFieldsDFN: boolean = false;
  @Input() file: string | null = null; 
  @Output() disableMainForm = new EventEmitter<string>();
  myDfnForm!: FormGroup;
  showForm: boolean = true;
  query: any;
  showMap: boolean = false;
  mapData: any;
  isLoading: boolean = false;
  showMessage: boolean = false;
  url: string = '';
  filename: string = '';
  msg: string = ''; 
  MessageToShow: any;
  upstream_screen = false;
  smp_connectivity_flag = false;
  flowName:string='N2P';
  dfnfile: string | null = null; 
  data_flag:boolean = false;
  
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router
  ) {

    this.myDfnForm = this.fb.group({
      // numberOfDjl: [],
      // //equipment: ['', Validators.required],
      // fjl_id: ['', Validators.required],
      // dfn_upstream_equipment_id: [],
      // fjl_structure_id: ['', Validators.required],
      // fsd_cable: ['', Validators.required],
      // fsd_cable_spec: ['', Validators.required],
      // formGroupsArray: this.fb.array([]),
    });
  }
  ngOnInit(): void {

  }

  fileUploaded(event: string) {
    this.dfnfile = event;
  }

  downloadFile() {
    // Path to the file in the assets folder
    const fileUrl = 'assets/sample_file/ada_dfn.xlsx';

    // Create an invisible anchor element
    const anchor = document.createElement('a');
    anchor.href = fileUrl;
    anchor.download = 'ADA_DFN.xlsx'; // Set the file name for the download

    // Trigger a click event on the anchor to start the download
    anchor.click();
  }

  onMduCall() {

  }
  get formGroupsArray(): FormArray {
    return this.myDfnForm?.get('formGroupsArray') as FormArray;
  }

  createFormGroup(index: number): FormGroup {
    return this.fb.group({
      // Define your form controls here
      // For example:
      djl_id: ['', Validators.required],
      djl_structure_id: ['', Validators.required],
      dss_cable: ['', Validators.required],
      dss_cable_spec: ['', Validators.required],
    });
  }

  callDataCleaning(){
    this.isLoading = true
    this.spinner.show();
    let body: any = {}
    let architectureType = ((this.inputData.value.architectureType != undefined) ? this.inputData.value.architectureType : 'Type3');
    this.query = `?ufa_category=${this.inputData.value.ufaCategory}&ada_id=${this.inputData.value.adaId}&loc_id_file=${this.file}&dfn_id_file=${this.dfnfile}`;      
    ////this.query += `&s18_path=C:\\Users\\deepika.goswami\\Downloads\\4BWE-02-05-01`
    ////this.query += `&s18_path=C:\\Users\\deepika.goswami\\Downloads\\6KGL-03-04-01`
    ////this.query += `&s18_path=C:\\Users\\deepika.goswami\\Downloads\\multiple_dfn\\4COR-20\\mapinfofiles`
    //this.query += `&s18_path=C:\\Users\\deepika.goswami\\Downloads\\6BNB-01-18-01-1\\6BNB-01-18-01`
    console.log(this.query)
    console.log(body)
    this.isLoading = true;
    this.spinner.show();

    this.apiService.onDataCleaning(body, this.query).subscribe(
      {
        next: response => {
          this.isLoading = false;          
          if(response.message == 'Data cleaning done'){
              this.toastr.success(response.message, 'Success Message');
              this.data_flag = false;
          } 
          else{
                this.toastr.error(response.message, 'Error Message');
                this.data_flag = true;              
          }
          this.isLoading = false;
          this.spinner.hide();
          // Handle the response data
        },
        error: error => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(`The API returned Unsuccessfull response : ${error}`, 'Error Message');
        },
      }
    );

  }
  
  onSubmit() {
    this.isLoading = true
    this.spinner.show();
    let body: any = {}
    //this.query = `?tech_type=${this.inputData.value.techType}&built_type=${this.inputData.value.builtType}&ufa_category=${this.inputData.value.ufaCategory}&architecture_type=${this.inputData.value.architectureType}&s18_path=${this.inputData.value.S18path}&ror_id=${this.inputData.value.rorId}&loc_id=${this.inputData.value.locId}&ada_id=${this.inputData.value.adaId}&fjl_structure_id=${this.inputData.value.fjlStru}`
    //this.query = `?tech_type=${this.inputData.value.techType}&ufa_category=${this.inputData.value.ufaCategory}&architecture_type=${this.inputData.value.architectureType}&ror_id=${this.inputData.value.rorId}&loc_id=${this.inputData.value.locId}&ada_id=${this.inputData.value.adaId}&fjl_structure_id=${this.inputData.value.fjlStru}`
    let architectureType = ((this.inputData.value.architectureType != undefined) ? this.inputData.value.architectureType : 'Type3');
    this.query = `?ufa_category=${this.inputData.value.ufaCategory}&ada_id=${this.inputData.value.adaId}&loc_id_file=${this.file}&dfn_id_file=${this.dfnfile}`;      
    ////this.query += `&s18_path=C:\\Users\\deepika.goswami\\Downloads\\5LSD-20-08-01\\5LSD-20-08-01`
    ////this.query += `&s18_path=C:\\Users\\deepika.goswami\\Downloads\\multiple_dfn\\4COR-20\\mapinfofiles`
    //this.query += `&s18_path=C:\\Users\\deepika.goswami\\Downloads\\6BNB-01-18-01-1\\6BNB-01-18-01`
    console.log(this.query)
    console.log(body)
    this.isLoading = true;
    this.spinner.show();

    this.apiService.onInitiateDfnN2P(body, this.query).subscribe(
      {
        next: response => {
          this.isLoading = false;
          this.showForm = false;
          if (response.message === 'select upstream equipment n2p') {
            this.showForm = false;
            this.upstream_screen = true;
            this.inputData = response;
            this.disableMainForm.emit();
          } else if (response.message === 'select existing smp') {
              this.smp_connectivity_flag = true;
              this.inputData = response;
              this.disableMainForm.emit();
          }
          else if (response.message == 'Pre-signed url has been generated') {
                  this.disableMainForm.emit();
                  this.showMessage = true; 
                  this.url = response.url;
                  this.filename = response.file_name;
                  this.msg = response.message;
                  this.MessageToShow = JSON.stringify(response);
          }
          else if(response.message == 'no path exists between fjl and djl/mpt'){
              this.toastr.error(response.message, 'Error Message');
                console.log('error');
                this.showForm = true;
          } 
          else {            
              if ('file_name' in response) {
                this.showMessage = true;
                this.MessageToShow = response;
                this.disableMainForm.emit();
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
                this.showForm = true;
              }
          }
          this.isLoading = false;
          this.spinner.hide();
          // Handle the response data
        },
        error: error => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(`The API returned Unsuccessfull response : ${error}`, 'Error Message');
        },
      }
    );

  }

  onNumberOfDjlChange(): void {
    const numberOfDjlControl = this.myDfnForm?.get('numberOfDjl')?.value;

    // Clear existing form groups
    while (this.formGroupsArray.length !== 0) {
      this.formGroupsArray.removeAt(0);
    }

    // Add new form groups
    for (let i = 0; i < numberOfDjlControl; i++) {
      this.formGroupsArray.push(this.createFormGroup(i));
    }
  }
}
